import { Fragment, useEffect, useState } from 'react';

/** CUBA gooey loader — auto-hides after first paint */
export function Loader() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = window.setTimeout(() => setShow(false), 1200);
    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <Fragment>
      <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
        <div className="loader-index">
          <span />
        </div>
        <svg>
          <defs />
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="11" result="blur" />
            <feColorMatrix
              in="blur"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            />
          </filter>
        </svg>
      </div>
    </Fragment>
  );
}
